export const NAV = {
    logo: "nav-logo",
    home: "nav-home",
    work: "nav-work",
    services: "nav-services",
    pricing: "nav-pricing",
    process: "nav-process",
    contact: "nav-contact",
    cta: "nav-cta",
    menuToggle: "nav-menu-toggle",
};

export const HERO = {
    section: "hero-section",
    primaryCta: "hero-primary-cta",
    secondaryCta: "hero-secondary-cta",
};

export const HOME = {
    problemSection: "problem-section",
    consequencesSection: "consequences-section",
    valueSection: "value-section",
    pricingSection: "pricing-section",
    pricingCta: "pricing-cta",
    processSection: "process-section",
    showcaseSection: "showcase-section",
    showcaseCta: "showcase-view-case-study",
    whyLakSection: "why-lak-section",
    testimonialsSection: "testimonials-section",
    finalCta: "final-cta",
};

export const PRELOADER = {
    root: "preloader-root",
};

export const WORK = {
    list: "work-list",
    projectCard: "work-project-card",
};

export const PROJECT = {
    hero: "project-hero",
    cta: "project-final-cta",
};

export const CONTACT = {
    form: "contact-form",
    step: (i) => `contact-step-${i}`,
    next: "contact-next",
    back: "contact-back",
    submit: "contact-submit",
    success: "contact-success",
    field: {
        name: "field-name",
        email: "field-email",
        business: "field-business",
        industry: "field-industry",
        website: "field-website",
        description: "field-description",
        goals: "field-goals",
        budget: "field-budget",
        timeline: "field-timeline",
    },
};

export const FOOTER = {
    root: "footer-root",
    enquireCta: "footer-enquire-cta",
};
